import React, { useEffect, useRef, useState } from 'react';
import './StatsBar.css';

const STATS = [
  { end: 50000, suffix: '+', label: 'Predictions Delivered', display: '50,000+' },
  { end: 98,    suffix: '%', label: 'Accuracy Rate',         display: '98%'      },
  { end: 12,    suffix: '+', label: 'Languages Served',      display: '12+'      },
  { end: 100,   suffix: '%', label: 'VTD Certified Only',    display: '100%'     },
];

/** Animated counter that counts up from 0 to `end` */
const useCountUp = (end, duration = 1800, active = false) => {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!active) return;
    let start = 0;
    const step = Math.ceil(end / (duration / 16));
    const timer = setInterval(() => {
      start += step;
      if (start >= end) { setCount(end); clearInterval(timer); }
      else setCount(start);
    }, 16);
    return () => clearInterval(timer);
  }, [end, duration, active]);
  return count;
};

const StatItem = ({ stat, active, index }) => {
  const count = useCountUp(stat.end, 1600 + index * 100, active);
  const display = active
    ? stat.end >= 1000
      ? count.toLocaleString('en-IN') + stat.suffix
      : count + stat.suffix
    : '0' + stat.suffix;

  return (
    <div className="stats__item">
      <span className="stats__value">{display}</span>
      <span className="stats__label">{stat.label}</span>
    </div>
  );
};

const StatsBar = () => {
  const [active, setActive] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) { setActive(true); observer.disconnect(); } },
      { threshold: 0.4 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="stats" ref={ref} aria-label="VTD Astrology statistics">
      <div className="stats__inner">
        {STATS.map((s, i) => (
          <React.Fragment key={s.label}>
            <StatItem stat={s} active={active} index={i} />
            {i < STATS.length - 1 && <span className="stats__divider" aria-hidden="true" />}
          </React.Fragment>
        ))}
      </div>
    </section>
  );
};

export default StatsBar;
